import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TerritoriesService, Territory } from '../../territories.service';

@Component({
  selector: 'app-select-territory',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressBarModule
  ],
  templateUrl: './select-territory.component.html',
  styleUrl: './select-territory.component.scss'
})
export class SelectTerritoryComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private territoriesService = inject(TerritoriesService);

  territories = computed(() => this.territoriesService.territories());
  isLoading = computed(() => this.territoriesService.isLoading());
  hasError = signal(false);

  selectedId: number | null = null;

  ngOnInit(): void {
    if (!this.territories().length) this.fetchTerritories();
  }

  fetchTerritories() {
    this.hasError.set(false);
    this.territoriesService.getTerritories().subscribe({
      error: () => this.hasError.set(true)
    });
  }

  confirm() {
    const territory = this.territories().find((t: Territory) => t.id === this.selectedId);
    if (!territory) return;
    this.activeModal.close(territory);
  }
}
